<div
    ng-form="fieldRecordAddressForm"
    class="well">
    <h5>Address</h5>
    <div class="row">
        <div class="col-xs-4">
            <label
                class="control-label"
                [ngClass]="{'required-input': isLocalityRequired()}"
                >Locality</label
            >
            <div
                class="input-group"
                ng-class="{'has-error': fieldRecordAddressForm.locality.$invalid
                        && (fieldRecordAddressForm.locality.$dirty || fieldRecordAddressForm.$submitted)}">
                <ng-select
                    class="nlr-ng-select"
                    #locality="ngModel"
                    [searchable]="false"
                    [clearable]="false"
                    name="locality"
                    id="locality"
                    placeholder="Select"
                    [items]="getLocalities()"
                    [trackByFn]="localityTrackBy"
                    bindLabel="localityName"
                    [ngModel]="selectedLocality"
                    (ngModelChange)="onSelectLocality($event)"
                    [required]="isLocalityRequired()">
                </ng-select>
            </div>
        </div>
        <div class="col-xs-2">
            <label class="control-label">Street/Road number</label>
            <div
                class="input-group"
                [ngClass]="{'has-error': roadNumber.invalid && roadNumber.dirty}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>
                <input
                    #roadNumber="ngModel"
                    type="text"
                    name="roadNumber"
                    id="roadNumber"
                    class="form-control"
                    [(ngModel)]="model.address.roadNumber"
                    (ngModelChange)="onChangeRoadNumber($event)" />
            </div>
        </div>
        <div class="col-xs-6">
            <label
                class="control-label"
                [ngClass]="{'required-input': isRoadRequired()}"
                >Street/Road name</label
            >
            <div
                class="input-group"
                [ngClass]="{'has-error': !isRoadNameSelected || (road.invalid && submitted)}">
                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-edit"></i>
                </span>

                <input
                    type="text"
                    name="road"
                    id="road"
                    #road="ngModel"
                    class="form-control"
                    autocomplete="off"
                    placeholder="Enter to search"
                    [(ngModel)]="selectedRoad"
                    [nlrTypehead]="localityRoadSearch"
                    (itemSelected)="roadNameSelected($event)"
                    [required]="isRoadRequired"
                    [readOnly]="isRoadDisabled()" />

                <span class="input-group-addon">
                    <i class="nlrp-icon nlrp-icon-search"></i>
                </span>
            </div>
        </div>
    </div>
</div>
